<div class="pricing-plan">
  <div class="iq-icon">
    <i aria-hidden="true" [class]="icon"></i>
  </div>
  <h4 class="iq-tw-5">{{ title }}</h4>
  <ng-content select="[cardBody]"></ng-content>
</div>
